<template>
    <div id="app">
        <main>
            <div class="lg:tw-container tw-flex tw-justify-between tw-flex-col lg:tw-flex-row">
                <div class="left-content tw-flex tw-items-center lg:tw-items-start lg:tw-justify-start tw-justify-center tw-flex-col">
                    <img src="~@/assets/img/makro-logo.svg" alt="makro logo" class="makro-logo">
                    <h1>Mais Makro para Todos</h1>
                    <p>
                        Sabia que já pode pedir um cartão temporário Makro?
                    </p>
                    <img src="~@/assets/img/outlet-illustration.png" alt="makro outlet illustration" class="outlet-illustration mobile">
                </div>
                <div class="right-content">                    
                    <Form v-if="!$store.state.formSuccess" />
                    <FormSuccess v-if="$store.state.formSuccess" />
                </div>
            </div>
            <img src="~@/assets/img/outlet-illustration.png" alt="makro outlet illustration" class="outlet-illustration desktop">
        </main>
        <section>
            <div class="tw-container tw-flex tw-justify-between tw-pt-12 md:tw-pt-32 md:tw-pb-8 tw-pb-10 tw-flex-col md:tw-flex-row">
                <article>
                    <img src="~@/assets/img/advantage-1.svg" alt="credit card">
                    <p>
                        <strong>Acesso exclusivo</strong> às lojas Makro
                    </p>
                </article>
                <article>
                    <img src="~@/assets/img/advantage-2.svg" alt="star">
                    <p>
                        <strong>Milhares de produtos</strong> e <strong>marcas</strong> que não encontra nos supermercados habituais
                    </p>
                </article>
                <article>
                    <img src="~@/assets/img/advantage-3.svg" alt="chef's hat">
                    <p>
                        Tudo o que precisa para as suas <strong>receitas mais exigentes</strong>
                    </p>
                </article>
                <article>
                    <img src="~@/assets/img/advantage-4.svg" alt="mask">
                    <p>
                        Faça as suas compras em <strong>segurança</strong>
                    </p>
                </article>
            </div>
        </section>
        <section class="tw-py-12 lg:tw-py-24 tw-pb-8 lg:tw-pb-20">
            <div class="tw-container">
                <h5>Veja como é fácil pedir o seu Cartão Makro:</h5>
                <div class="articles">
                    <article>
                        <img src="~@/assets/img/one.svg" alt="mask">
                        <p>
                            Preencha o <strong>formulário</strong> acima
                        </p>
                    </article>
                    <article>
                        <img src="~@/assets/img/two.svg" alt="mask">
                        <p>
                            <strong>Receba</strong> um email com o seu <strong>número do Cartão Makro</strong>
                        </p>
                    </article>
                    <article>
                        <img src="~@/assets/img/three.svg" alt="mask">
                        <p>
                            <strong>Registe</strong> o seu <strong>cartão</strong> no nosso site
                        </p>
                    </article>
                    <article>
                        <img src="~@/assets/img/four.svg" alt="mask">
                        <p>
                            <strong>E já está!</strong> Aceda à loja utilizando a <strong>APP Makro Companion</strong> (iOS/Android) com os dados do registo efetuado
                        </p>
                    </article>
                </div>
            </div>
        </section>
        <footer>
            <p>
                © MAKRO Portugal
            </p>
        </footer>
        <div class="tw-py-5">
            <div class="tw-container tw-text-center lg:tw-text-left">
                <small class="tw-text-xs tw-text-gray-500"></small>
            </div>
        </div>
        <ModalContainer>
            <Terms/>
        </ModalContainer>

        <KwPixel/>
    </div>
</template>

<script>
import Form from '@/components/Form.vue';
import FormSuccess from '@/components/FormSuccess.vue';
import KwPixel from '@/components/KwPixel.vue';
import ModalContainer from '@/components/ModalContainer.vue';
import Terms from '@/components/Terms.vue';

export default {
    components: {
        Form,
        FormSuccess,
        KwPixel,
        ModalContainer,
        Terms,
    },
    mounted() {
        window.cmp_setlang = document.documentElement.lang;
        axios
            .get('https://api.ipify.org?format=json')
            .then((response) => {
                this.$store.state.ip = response.data.ip;
            })
            .then(() => {
                const data = {
                    ip: this.$store.state.ip,
                    url: window.location.hostname,
                    pubid: this.pubid,
                    utm_source: this.$route.query.utm_source,
                    utm_campaign: this.$route.query.utm_campaign,
                    utm_medium: this.$route.query.utm_medium,
                    utm_content: this.$route.query.utm_content,
                    utm_term: this.$route.query.utm_term,
                    ua_device: this.$store.state.ua_device,
                    ua_browser: this.$store.state.ua_browser,
                    ua_os: this.$store.state.ua_os,
                };
                axios.post(`${process.env.VUE_APP_BACKOFFICE_ENDPOINT}/api/trk`, data)
                    .then((kwResponse) => console.log(kwResponse))
                    .catch((error) => console.log(error));
            });
        axios
            .post(`${process.env.VUE_APP_BACKOFFICE_ENDPOINT}/api/token`)
            .then((response) => {
                this.$store.state.token = response.data;
            })
            .catch((error) => console.log(error));
    },
};
</script>
<style>

</style>
